import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  REFRESH_AUTH_TOKEN
} from '../types';

import { useHistory } from 'react-router-dom';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: false,
  user: null,
  tokenId: undefined,
  goBackToLogin: false
};
// const history = useHistory();
export default function(state = initialState, action: any) {
  
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        loading: true
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('tokenId', action.payload.tokenId);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        loading: false,
        redirectTo: action.redirect
        // redirectTo: "/demande_achat"
      };
    case REFRESH_AUTH_TOKEN:
      if(!action.payload.token || action.payload.token === "null")
        localStorage.removeItem('token')
      else
        localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        ...action.payload
      }
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        loading: false,
        goBackToLogin: true
      };
    default:
      return state;
  }
}
